module.exports = __webpack_public_path__ + "media/packs/images/flags/SG-400d69668d2fbac3d5c868fe9f813f75.png";